import React from 'react';
import { MuiThemeProvider } from "@material-ui/core/styles";
import Snackbar from '@material-ui/core/Snackbar';
import { muiTheme } from '../../../styling/Styles';

const ViewAnnotationsSnackBar = (props) => {

    const {
        openViewAnnotationsSnackBar,
        setOpenViewAnnotationsSnackBar
    } = props;

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpenViewAnnotationsSnackBar(false);
    };

    const [displaySnackBar, setDisplaySnackBar] = React.useState(true);

    return (
        <MuiThemeProvider theme={muiTheme}>
            {displaySnackBar &&
                <Snackbar
                anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
                }}
                open={openViewAnnotationsSnackBar}
                onClose={handleClose}
                autoHideDuration={8000}
                message= "This page is in view annotations mode - "
                action={
                    < span style={{borderStyle: 'solid', 'borderColor': '#e83c52', 'cursor': 'pointer'}} onClick={() => setDisplaySnackBar(false)} aria-hidden="true" >
                        <span>  &nbsp;Got it ! &nbsp; </span>
                    </span >
                }
            
            />
            }
        </MuiThemeProvider>
    )

}

export default ViewAnnotationsSnackBar;